import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getUserInfo,
  updateUserInfo,
  dispatchModelsAndFavModelsInStore,
  getFileUrl,
  updateUserImageUrl,
  getFavModels,
} from "../actions";
import { isLoggedIn } from "../auth";
import logger from "../utils/logger";

function useInitialLoad() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async () => {
    try {
      setIsLoading(true);
      // User info and favorites are independent — fetch them concurrently
      // rather than in series so initial load is one round-trip, not two.
      const [userInfoResponse, favModels] = await Promise.all([getUserInfo(), getFavModels()]);
      dispatch(updateUserInfo(userInfoResponse));
      logger.debug("Fetched favorite models", favModels);
      dispatch(dispatchModelsAndFavModelsInStore(favModels));

      // The avatar URL depends on the profile, so it runs after. Optional
      // chaining guards against a failed/blank profile (getUserInfo returns
      // an error object on failure) so we never throw dereferencing it.
      const userImg = userInfoResponse?.account_info?.user_img;
      if (userImg) {
        const userImageResponse = await getFileUrl(userImg);
        if (userImageResponse) {
          dispatch(updateUserImageUrl(userImageResponse.data));
        }
      }
    } catch (error) {
      // Handle any errors that occurred during the API calls
      logger.error("An error occurred during initial data load:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (isLoggedIn()) {
      fetchData();
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isLoading, setIsLoading };
}

export default useInitialLoad;
